import { useTheme, useMediaQuery, Box } from "@mui/material"
import React, { ReactElement, useMemo } from "react"

import { useBoolean } from "src/hooks/useBoolean"
import DepositModal from "src/pages/Stake/components/DepositModal"
import useXFerState from "src/pages/Stake/hooks/useXFerState"
import useTotalVault from "src/hooks/BoostFarming/useTotalVault"
import { useGetBoostedNfts } from "src/hooks/BoostFarming/useFarmBoostContract"

import Text from "../Text"
import QuestionHelper from "../QuestionHelper"
import AddBoostFactorModal from "./AddBoostFactorModal"
import NftStakingModal from "./NftStakingModal"

export default function AddBoostFactor(): ReactElement {
  const theme = useTheme()
  const isMdDown = useMediaQuery(theme.breakpoints.down("md"))
  const totalVault = useTotalVault()
  const { data: stakedNftIds } = useGetBoostedNfts()
  const [showModal, openModal, closeModal] = useBoolean(false)
  const { openedDepositModal, openedNftStakeModal } = useXFerState()

  const boostText = useMemo(() => {
    let txt = "No boost power yet"
    if (totalVault.gt(0)) {
      txt = "xFER locked"
      if (stakedNftIds && stakedNftIds.length > 0) {
        txt += " & NFT staked"
      }
    }
    return txt
  }, [totalVault, stakedNftIds])
  return (
    <Box
      flex={1}
      alignSelf={isMdDown ? "" : "flex-start"}
      width={isMdDown ? "100%" : ""}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb="4px"
      >
        <Box alignItems="center" display="flex">
          <Text color="dim" size="micro">
            Boost Power
          </Text>
          <QuestionHelper
            text="Boost Power is the amount of rewards you can get relative to the base reward emitted to the pool."
            ml="4px"
          />
        </Box>
        <Text
          bold
          size="small"
          color="#009BE0"
          sx={{
            cursor: "pointer",
          }}
          onClick={openModal}
        >
          {totalVault.gt(0) ? "Manage" : "Get Boost Power"}
        </Text>
      </Box>
      <Text>{boostText}</Text>
      <AddBoostFactorModal open={showModal} onClose={closeModal} />
      {openedDepositModal && (
        <DepositModal
          defaultSelectedPool={openedDepositModal.defaultSelectedPool}
        />
      )}
      {openedNftStakeModal && <NftStakingModal />}
    </Box>
  )
}
